import API from "../../../utils/helpers/API.helpers";

const RevisiMahasiswaService = {
  async createRevisiMahasiswa(revisiMahasiswaDetails) {
    return await API.post({
      endpoint: "/revisi-mahasiswa/",
      data: revisiMahasiswaDetails,
    });
  },
};

export default RevisiMahasiswaService;
